import { Network } from '../../../../utils/network'
import { Events } from '../../../../utils/servicesEvents'
import { Formatter } from '../../formatter'

import urls from '../urls.json'

async function createManyDeliveryLocations(data, onSuccessEvent, onErrorEvent) {
  const response = await sendRequest(data)
  const parsedResponse = parseResponse(response, Formatter)
  const onDoneEvent = parsedResponse.success ? onSuccessEvent : onErrorEvent
  Events.dispatchEvent(onDoneEvent, parsedResponse)
}

async function sendRequest(data) {
  const url = urls.proxyRequestSimultaneous
  const storeId = await self.servicesVars.getStoreId()

  const body = {
    requests: data.cities.map(city => {
      return {
        method: 'post',
        url: urls.createDeliveryLocation,
        body: {
          storeId: storeId,
          deliveryCost: data.deliveryCost,
          currency: data.currency,
          city: city.name,
          latitude: city.latitude,
          longitude: city.longitude,
          countryName: city.country,
          countryCode: city.countryCode,
          state: city.state,
        },
      }
    }),
  }
  const response = await Network.sendPostRequest(url, body)
  return response
}

function parseResponse(response) {
  if (
    response &&
    (response.status.code === 200 || response.status.code === 201)
  ) {
    let atLeastOneCreated = false
    let allLocationsCreated = true
    Object.keys(response.response).forEach(key => {
      const isCreated = response.response[key]?.body?.statusCode == 200
      if (isCreated) atLeastOneCreated = true
      if (!isCreated) allLocationsCreated = false
    })
    return {
      atLeastOneCreated,
      allLocationsCreated,
      statusCode: 200,
      success: true,
    }
  }
  if (response === null || response.status.code === 401) {
    return {
      success: false,
    }
  }
  return Network.defaultResponseParsing(response)
}

export { createManyDeliveryLocations }
